import React from 'react';
import { CommunityGlyph } from '../../components/icons/BeelyvIcons';
import { Avatar } from '../../components/Avatar';
import { PageHeader } from '../../components/PageHeader';
import { StateScreen } from '../../components/StateScreen';
import { Button } from '../../components/ui/Button';
import { Card, SectionTitle } from '../../components/ui/Card';
import { engagementConfig, leagueMembers } from '../../data/engagement';
import { people } from '../../data/people';
import { useEngagement } from '../../contexts/EngagementContext';
import { useLocale } from '../../contexts/LocaleContext';

/** MOB/Stats/League — optional small-group weekly league, consistency only. */
export function League() {
  const {
    t
  } = useLocale();
  const engagement = useEngagement();
  const league = engagementConfig.league;
  const cycle = league.cycleLengthDays;
  const resetLine = t('eng.league.p3', {
    day: t(`eng.weekday.${league.resetDay}`)
  });
  if (!engagement.leagueOptIn) {
    return <div className="px-2 pb-2" data-id="element-2484" data-mp="17cebvsm5wzt8">
        <PageHeader title={t('eng.league.title')} subtitle={t('eng.league.subtitle')} showBack data-id="element-2485" data-mp="17bmrldy0moi9" />
        <StateScreen icon={<CommunityGlyph size={24} data-id="element-2487" data-mp="12ctbddrcgjee" />} title={t('eng.league.introTitle')} body={t('eng.league.introBody', {
        n: league.groupSize
      })} points={[t('eng.league.p1'), t('eng.league.p2'), resetLine]} primary={{
        label: t('eng.league.join'),
        onClick: () => engagement.setLeagueOptIn(true)
      }} data-id="element-2486" data-mp="12e4edbcytn4g" />
      </div>;
  }
  const members = [...leagueMembers].sort((a, b) => b.checkDays - a.checkDays);
  return <div className="px-2 pb-2" data-id="element-2488" data-mp="xe8enobawhup">
      <PageHeader title={t('eng.league.title')} subtitle={t('eng.league.subtitle')} showBack data-id="element-2489" data-mp="xf9z2je7igp3" />

      <section data-id="element-2490" data-mp="sn9w0i2ub7oa">
        <SectionTitle data-id="element-2491" data-mp="smqc4vtmq97m">{t('eng.league.group')}</SectionTitle>
        <p className="-mt-1 mb-2 text-[11.5px] text-muted" data-id="element-2492" data-mp="4xns5hbiw49y">{t('eng.league.metric')}</p>
        <ul className="rounded-card border border-sand-line bg-white/70 px-2" data-id="element-2493" data-mp="3w48ggta70y3a">
          {members.map(member => {
          const person = people.find(item => item.id === member.personId);
          if (!person) return null;
          const me = person.id === 'me';
          return <li key={member.personId} className={`flex items-center gap-2 border-b border-sand-line py-2 last:border-b-0 ${me ? 'font-bold' : ''}`} data-id="element-2494" data-mp="29qwzucfeiswg">
                <Avatar src={person.avatar} name={person.name} size={36} data-id="element-2495" data-mp="1h27zwgq30tma" />
                <span className="min-w-0 flex-1 truncate text-[13.5px] text-deep" data-id="element-2496" data-mp="1h4ccdn21r0y6">
                  {me ? t('eng.league.you') : person.name}
                </span>
                <span className="flex gap-[3px]" aria-hidden="true" data-id="element-2497" data-mp="1qzcpkqj4z77u">
                  {Array.from({
                length: cycle
              }).map((_, day) => <span key={day} className={`h-[14px] w-[6px] rounded-pill ${day < member.checkDays ? me ? 'bg-gold' : 'bg-soft' : 'bg-sand-deep'}`} data-id="element-2498" data-mp="1uzwlxrvvy6sx" data-mpi={day} />)}
                </span>
                <span className="bee-num w-[62px] shrink-0 text-right text-[11.5px] text-muted" data-id="element-2499" data-mp="uvngwr4yfkzr">
                  {t('eng.league.days', {
                n: member.checkDays,
                total: cycle
              })}
                </span>
              </li>;
        })}
        </ul>
      </section>

      <Card className="mt-2 p-2" data-id="element-2500" data-mp="h25tuwd27q4z">
        <p className="text-[12px] leading-snug text-deep" data-id="element-2501" data-mp="c3be63ae2hp3">{t('eng.league.note')}</p>
        <ul className="mt-1 space-y-[2px] text-[11.5px] text-muted" data-id="element-2502" data-mp="c0ym2xax2qyb">
          <li data-id="element-2503" data-mp="72oqilla5oc6">{t('eng.league.p1')}</li>
          <li data-id="element-2504" data-mp="32mzd6d68db5">{t('eng.league.p2')}</li>
          <li data-id="element-2505" data-mp="33ob7d20h3tx">{resetLine}</li>
        </ul>
      </Card>

      <Button variant="quiet" fullWidth className="mt-2" onClick={() => engagement.setLeagueOptIn(false)} data-id="element-2506" data-mp="34hhye0yztc2">
        {t('eng.league.leave')}
      </Button>
    </div>;
}